define(['underscore'], (_)=> {
    return {
        /** Converts a type info or function returning a type info into the property definition. */
        toPropertyDef: (typeRef)=> {
            if (_.isFunction(typeRef)) {
                return {
                    'get': typeRef
                };
            }

            return {
                'value': typeRef
            };
        }
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/metamirror/_PropertyDefinitionUtil.js